import {
    GET_SCOUT_OBSERVATION_LIST_REQUEST, GET_SCOUT_OBSERVATION_LIST, GET_SCOUT_OBSERVATION_CONFIG_REQUEST, GET_SCOUT_OBSERVATION_CONFIG
} from '../constants/action-types';

const initialState = {
    isRequesting: false,
    scoutObservationList: [],
    isConfigRequesting: false,
    scoutObservationConfig: []
}

export default (state = initialState, action) => {
    switch (action.type) {
        case GET_SCOUT_OBSERVATION_LIST_REQUEST:
            state = { ...state, isRequesting: true, scoutObservationList: initialState.scoutObservationList };
            break;
        case GET_SCOUT_OBSERVATION_LIST:
            state = { ...state, isRequesting: false, scoutObservationList: action.payload };
            break;
        case GET_SCOUT_OBSERVATION_CONFIG_REQUEST:
            state = { ...state, isConfigRequesting: true, scoutObservationConfig: initialState.scoutObservationConfig };
            break;
        case GET_SCOUT_OBSERVATION_CONFIG:
            state = { ...state, isConfigRequesting: false, scoutObservationConfig: action.payload };
            break;
        default:
            break;
    }
    return state;
}